module.exports = __webpack_public_path__ + "img/health8_7-9-2021.9f3fecac.jpg";